import cn from 'classnames';
import { ReactNode } from 'react';
import CloseButton from '../CloseButton';
import styles from './Chip.module.scss';

type ChipProps = {
  children: ReactNode;
  className?: string;
  labelProps?: { className?: string };
  deletable?: boolean;
  onDelete?: () => void;
  onClick?: () => void;
  variant?: 'primary' | 'primary-outlined' | 'secondary' | 'secondary-outlined';
};

const Chip = ({
  children,
  className,
  variant = 'primary',
  deletable = false,
  labelProps = {},
  onDelete = () => {},
  onClick = () => {},
}: ChipProps) => {
  const classes = cn({
    [styles.root]: true,
    [styles.primary]: variant === 'primary',
    [styles.primaryOutlined]: variant === 'primary-outlined',
  });

  return (
    <div role="button" onClick={onClick} className={cn(classes, className)}>
      <span className={cn(styles.label, labelProps.className)}>{children}</span>

      {deletable && <CloseButton className={styles.deleteControl} onClick={onDelete} />}
    </div>
  );
};

export default Chip;
